import React, { useState, useEffect } from 'react';
import DeleteIcon from "@mui/icons-material/Delete";
import { Button, Container, Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getFirestore, doc, getDoc, deleteDoc, updateDoc } from "firebase/firestore";
import { auth } from "../../firebase";
import MediaItem from "../search/MediaItem";

// Define media types and timeout
const mediaTypes = ["movie", "tv", "people"];

const FavoriteList = ({ setError: setFavoriteError, setLoading: setFavoriteLoading }) => {
    const [filteredMedias, setFilteredMedias] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const dispatch = useDispatch();

    // Fetch favorites when component mounts
    useEffect(() => {
        fetchFavorites();
    }, []);

    // Fetch favorites from the server
    const fetchFavorites = async () => {
        try {
            const user = auth.currentUser;
            const isOnline = navigator.onLine;

            if (!user || !isOnline) {
                setFavoriteError("You are either not logged in or currently offline. Please log in and connect to the internet.");
                return;
            }

            setFavoriteLoading(true);

            const userId = user.uid;
            const favoritesRef = doc(getFirestore(), "userFavorite", userId);

            const favoritesDoc = await getDoc(favoritesRef);
            if (favoritesDoc.exists()) {
                const favoritesData = favoritesDoc.data().favorites || {};
                const fetchedFavorites = Object.keys(favoritesData).map(mediaId => {
                    const favoriteDetails = favoritesData[mediaId];
                    const mediaType = favoriteDetails.movieId ? 'movie' : 'tv';
                    const posterPath = favoriteDetails.posterPath;
                    const { mediaTitle, mediaRate } = favoriteDetails;
                    return {
                        id: mediaId,
                        media: {
                            favoriteDetails,
                            mediaId,
                            mediaType,
                            posterPath,
                            mediaTitle,
                            mediaRate
                        }
                    };
                });
                setFilteredMedias(fetchedFavorites);
            } else {
                setFavoriteError("No favorites found.");
            }
        } catch (error) {
            console.error("Error fetching favorites: ", error);
            setFavoriteError("Error fetching favorites. Please try again later.");
        } finally {
            setFavoriteLoading(false);
        }
    };

    // Handle media item click
    const handleMediaItemClick = (media) => {
        // Handle media item click action if needed
    };

    // Handle remove button click
    const handleRemoveButtonClick = async (id) => {
        try {
            const user = auth.currentUser;
            if (!user) {
                console.error("User not logged in");
                return;
            }
            const userId = user.uid;
            const favoritesRef = doc(getFirestore(), "userFavorite", userId);

            const favoritesDoc = await getDoc(favoritesRef);
            if (favoritesDoc.exists()) {
                const favoritesData = favoritesDoc.data().favorites || {};
                if (favoritesData[id]) {
                    delete favoritesData[id];
                    await updateDoc(favoritesRef, { favorites: favoritesData });
                    fetchFavorites(); // Refresh the list of favorites after removing one
                } else {
                    console.error("Favorite document does not exist:", id);
                }
            } else {
                console.error("Favorites document does not exist for user:", userId);
            }
        } catch (error) {
            console.error("Error removing favorite from list: ", error);
        }
    };

    return (
        <Container className="mt-5">
            <h1 className="mb-4 justify-content-center">Favorites</h1>
            <Row xs={1} md={2} lg={3} className="g-4">
                {/* Render media items */}
                {filteredMedias.map(({ id, media }) => (
                    <Col key={id} className="mb-4 position-relative">
                        {/* Render the image fetched from posterPath */}
                        {media.posterPath && (
                            <img
                                src={media.posterPath}
                                alt={media.mediaTitle}
                                className="card-img-top img-fluid"
                            />
                        )}
                        {/* Render the MediaItem component */}
                        <div className="position-absolute top-0 start-0 w-100 h-100" style={{ opacity: 0 }}>
                            <MediaItem media={media} mediaType={media.mediaType} />
                        </div>
                        {/* Render remove button */}
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<DeleteIcon />}
                            onClick={() => {
                                handleRemoveButtonClick(id); // Pass id as an argument
                                alert("Post removed successfully!"); // Show an alert indicating post removal
                            }}
                            className="position-absolute top-0 end-0 mt-2"
                            style={{
                                backgroundColor: "white",
                                color: "black",
                                border: "2px solid",
                                borderRadius: "10px",
                                padding: "8px 16px",
                                fontWeight: "bold",
                                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.9)"
                            }}
                        >
                            Remove
                        </Button>




                    </Col>
                ))}
            </Row>
            {/* Render loading message if loading */}
            {loading && <p className="mt-3 text-center">Loading...</p>}
            {/* Render error message if error */}
            {error && <p className="mt-3 text-danger text-center">{error}</p>}
        </Container>
    );
};

export default FavoriteList;